// src/components/common/forms/EntityFormFooter.tsx
import React from 'react';

interface EntityFormFooterProps {
  helpText?: string;
  pendingChangesCount?: number;
  customMessage?: React.ReactNode;
}

export const EntityFormFooter: React.FC<EntityFormFooterProps> = ({
  helpText = '💡 Double-cliquez sur un champ pour le modifier.',
  pendingChangesCount = 0,
  customMessage,
}) => {
  return (
    <div className="border-t bg-gray-50 px-6 py-3">
      <p className="text-sm text-gray-600">{helpText}</p>
      {pendingChangesCount > 0 && (
        <p className="text-sm text-orange-600 mt-1">
          ⚠️ {pendingChangesCount} changement(s) en attente de sauvegarde.
        </p>
      )}
      {customMessage && (
        <div className="mt-2">{customMessage}</div>
      )}
    </div>
  );
};